(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    // Phones: the sticky header slides away while scrolling down and returns on scroll up.
    // The attribute is only read by the mobile rule in skinstead-components.css.
    let last = window.scrollY;
    let frame = 0;
    window.addEventListener(
      'scroll',
      () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          const y = Math.max(window.scrollY, 0);
          if (Math.abs(y - last) < 8) return;
          document.documentElement.toggleAttribute('data-ss-header-away', y > last && y > 120);
          last = y;
        });
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-results"] && !Shopify.designMode) return;
  try {
    
  class PdpCompare extends HTMLElement {
    connectedCallback() {
      const range = this.querySelector('input[type="range"]');
      if (!range) return;
      range.addEventListener('input', () => {
        this.style.setProperty('--pdp-compare', `${range.value}%`);
      });
    }
  }
  if (!customElements.get('pdp-compare')) customElements.define('pdp-compare', PdpCompare);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-ai-feature"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target.closest('[data-ai-open], [data-ai-ask]') : null;
      if (!target || !window.SkinsteadAssistant || !window.SkinsteadAssistant.instance) return;
      event.preventDefault();
      if (target.hasAttribute('data-ai-ask')) window.SkinsteadAssistant.ask(target.getAttribute('data-ai-ask'));
      else window.SkinsteadAssistant.open();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // On phones: start with every row closed; "View all FAQs" reveals the rows past the fourth.
    const run = () => {
      if (window.matchMedia('(max-width: 749px)').matches) {
        document.querySelectorAll('.ss-faq__row[open]').forEach((row) => row.removeAttribute('open'));
      }
    };
    document.addEventListener('click', (event) => {
      const more = event.target.closest('[data-ss-faq-more]');
      if (!more) return;
      more.previousElementSibling.classList.add('is-all');
      more.hidden = true;
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-ingredient-grid"] && !Shopify.designMode) return;
  try {
    
  class SsIngredientRow extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[ref="track"]');
      if (!track) return;
      const update = () => {
        const visible = track.clientWidth / track.scrollWidth;
        const offset = track.scrollLeft / track.scrollWidth;
        this.style.setProperty('--ss-ing-progress', `${Math.min(100, visible * 100)}%`);
        this.style.setProperty('--ss-ing-offset', `${offset * 100}%`);
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }
  if (!customElements.get('ss-ingredient-row')) customElements.define('ss-ingredient-row', SsIngredientRow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-ingredient-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ssReady) return;
      root.dataset.ssReady = 'true';
      const track = root.querySelector('[data-ss-hub-track]');
      const thumb = root.querySelector('[data-ss-hub-thumb]');
      if (!track) return;
      const current = track.querySelector('.is-current');
      if (current && current !== track.firstElementChild) {
        track.scrollLeft = Math.max(0, current.offsetLeft - track.offsetLeft - 16);
      }
      if (!thumb) return;
      const update = () => {
        const visible = track.clientWidth / Math.max(1, track.scrollWidth);
        const max = Math.max(1, track.scrollWidth - track.clientWidth);
        const progress = Math.min(1, track.scrollLeft / max);
        thumb.style.width = `${Math.max(8, visible * 100)}%`;
        thumb.style.transform = `translateX(${progress * (100 / Math.max(0.08, visible) - 100)}%)`;
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    };
    const run = () => document.querySelectorAll('[data-ss-hub]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-lead-capture"] && !Shopify.designMode) return;
  try {
    
  class SsLeadCapture extends HTMLElement {
    connectedCallback() {
      const key = 'ss-lead-capture';
      const posted = this.querySelector('.ss-lead__done');
      try {
        if (posted) { this.hidden = false; localStorage.setItem(key, 'done'); return; }
        if (localStorage.getItem(key) === 'done' || sessionStorage.getItem(key)) return;
      } catch (e) { return; }
      const show = () => {
        if (!this.hidden) return;
        this.hidden = false;
        try { sessionStorage.setItem(key, 'shown'); } catch (e) {}
        window.removeEventListener('scroll', onScroll);
        clearTimeout(timer);
      };
      const onScroll = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= 0.5) show();
      };
      const timer = setTimeout(show, (Number(this.dataset.delay) || 40) * 1000);
      window.addEventListener('scroll', onScroll, { passive: true });
      this.querySelector('[ref="close"]')?.addEventListener('click', () => {
        this.hidden = true;
        try { localStorage.setItem(key, 'done'); } catch (e) {}
      });
      this.querySelector('form')?.addEventListener('submit', () => {
        try { localStorage.setItem(key, 'done'); } catch (e) {}
      });
    }
  }
  if (!customElements.get('ss-lead-capture')) customElements.define('ss-lead-capture', SsLeadCapture);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-life-stage"] && !Shopify.designMode) return;
  try {
    
  class SsLifeStageRow extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[ref="track"]');
      if (!track) return;
      const update = () => {
        const visible = track.clientWidth / track.scrollWidth;
        const offset = track.scrollLeft / track.scrollWidth;
        this.style.setProperty('--ss-life-progress', `${Math.min(100, visible * 100)}%`);
        this.style.setProperty('--ss-life-offset', `${offset * 100}%`);
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }
  if (!customElements.get('ss-life-stage-row')) customElements.define('ss-life-stage-row', SsLifeStageRow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-pdp-inside"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ssReady) return;
      root.dataset.ssReady = 'true';
      const track = root.querySelector('[data-ss-inside-track]');
      const thumb = root.querySelector('[data-ss-inside-thumb]');
      if (!track || !thumb) return;
      const update = () => {
        const visible = track.clientWidth / Math.max(1, track.scrollWidth);
        const max = Math.max(1, track.scrollWidth - track.clientWidth);
        const progress = Math.min(1, track.scrollLeft / max);
        thumb.style.width = `${Math.max(8, visible * 100)}%`;
        thumb.style.transform = `translateX(${progress * (100 / Math.max(0.08, visible) - 100)}%)`;
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    };
    const run = () => document.querySelectorAll('[data-ss-inside]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-pdp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ssReady) return;
      root.dataset.ssReady = 'true';

      // Gallery: thumbnails, arrows, dots, swipe
      const slides = root.querySelector('[data-ss-slides]');
      const thumbs = Array.from(root.querySelectorAll('.ss-pdp__thumb'));
      const dots = Array.from(root.querySelectorAll('.ss-pdp__dots span'));
      const goTo = (i) => {
        if (!slides) return;
        const items = slides.children;
        const idx = Math.max(0, Math.min(i, items.length - 1));
        slides.scrollTo({ left: items[idx].offsetLeft - slides.offsetLeft, behavior: 'smooth' });
      };
      const current = () => (slides ? Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)) : 0);
      thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.index))));
      root.querySelectorAll('.ss-pdp__nav').forEach((b) => b.addEventListener('click', () => goTo(current() + Number(b.dataset.dir))));
      const thumbRow = root.querySelector('.ss-pdp__thumbrow');
      const thumbStrip = root.querySelector('.ss-pdp__thumbs');
      const fitThumbs = () => {
        if (!thumbRow || !thumbStrip) return;
        thumbRow.classList.toggle('is-static', thumbStrip.scrollWidth <= thumbStrip.clientWidth + 1);
      };
      fitThumbs();
      window.addEventListener('resize', fitThumbs, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(fitThumbs).observe(thumbStrip || root);
      if (slides) {
        let timer;
        slides.addEventListener('scroll', () => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            const i = current();
            thumbs.forEach((t, n) => (n === i ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')));
            const strip = root.querySelector('.ss-pdp__thumbs');
            const active = thumbs[i]?.parentElement;
            if (strip && active) {
              const left = active.offsetLeft - strip.offsetLeft;
              if (left < strip.scrollLeft || left + active.offsetWidth > strip.scrollLeft + strip.clientWidth) {
                strip.scrollTo({ left: Math.max(0, left - 8), behavior: 'smooth' });
              }
            }
            dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
          }, 60);
        }, { passive: true });
      }

      // Tabs
      root.querySelectorAll('[data-ss-tabs]').forEach((wrap) => {
        const tabs = Array.from(wrap.querySelectorAll('[role="tab"]'));
        const select = (tab) => {
          tabs.forEach((t) => {
            const on = t === tab;
            t.setAttribute('aria-selected', String(on));
            t.tabIndex = on ? 0 : -1;
            const panel = wrap.querySelector('#' + t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
        };
        tabs.forEach((t, i) => {
          t.addEventListener('click', () => select(t));
          t.addEventListener('keydown', (e) => {
            const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
            if (!d) return;
            e.preventDefault();
            const n = tabs[(i + d + tabs.length) % tabs.length];
            select(n);
            n.focus();
          });
        });
      });

      // Sticky buy bar: shows once the main Add to cart leaves the viewport
      const buy = root.querySelector('[data-ss-buy]');
      const sticky = root.querySelector('[data-ss-sticky]');
      if (buy && sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
          document.body.classList.toggle('ss-sticky-open', !sticky.hidden);
        }).observe(buy);
        sticky.querySelector('[data-ss-sticky-buy]')?.addEventListener('click', () => {
          const submit = buy.querySelector('button[type="submit"], .add-to-cart-button');
          if (submit) submit.click();
          else buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    };
    const run = () => document.querySelectorAll('[data-ss-pdp]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-routine-finder"] && !Shopify.designMode) return;
  try {
    
  class SsRoutineFinder extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('[ref="form"]');
      const note = this.querySelector('[ref="note"]');
      if (!form) return;
      form.addEventListener('change', (event) => {
        if (event.target.name === 'ss_pregnant' && note) note.hidden = event.target.value !== 'yes';
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = new FormData(form);
        const base = data.get('ss_concern') || this.dataset.fallback || '/collections/all';
        const url = new URL(base, window.location.origin);
        const skin = data.get('filter.p.tag');
        if (skin) url.searchParams.append('filter.p.tag', skin);
        const pregnant = data.get('ss_pregnant');
        const param = this.dataset.pregnancyParam;
        if (pregnant === 'yes' && param && param.includes('=')) {
          const [key, value] = param.split('=');
          url.searchParams.append(key, value);
        }
        document.dispatchEvent(new CustomEvent('ss:track', { detail: { event: 'routine_finder_submit', concern: base, skin_type: skin || '', pregnant: pregnant || '' } }));
        window.location.href = url.pathname + url.search;
      });
    }
  }
  if (!customElements.get('ss-routine-finder')) customElements.define('ss-routine-finder', SsRoutineFinder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-routine"] && !Shopify.designMode) return;
  try {
    
  class SsRoutineStepper extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.track = this.querySelector('[ref="track"]');
      this.querySelectorAll('[data-set-time]').forEach((button) => {
        button.addEventListener('click', () => {
          this.dataset.time = button.dataset.setTime;
          this.querySelectorAll('[data-set-time]').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        });
      });
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index, true));
        tab.addEventListener('keydown', (event) => {
          const keys = { ArrowRight: 1, ArrowLeft: -1 };
          if (!(event.key in keys)) return;
          event.preventDefault();
          const next = (index + keys[event.key] + this.tabs.length) % this.tabs.length;
          this.select(next, true);
          this.tabs[next].focus();
        });
      });
      if (this.track) {
        let timer;
        this.track.addEventListener('scroll', () => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            const width = this.panels[0]?.getBoundingClientRect().width || 1;
            const index = Math.round(this.track.scrollLeft / width);
            this.select(Math.min(index, this.tabs.length - 1), false);
          }, 80);
        }, { passive: true });
      }
    }
    select(index, scroll) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      if (scroll && this.track && this.panels[index]) {
        this.track.scrollTo({ left: this.panels[index].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }
    }
  }
  if (!customElements.get('ss-routine-stepper')) customElements.define('ss-routine-stepper', SsRoutineStepper);

  } catch(e) { console.error(e); }
})();
})();
